var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeClosedNoWidth = function SvgEyeClosedNoWidth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-closed-no-width_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.307 14.693a.66.66 0 0 0 .942 0l2.605-2.604.044-.044 1.586-1.586a2.889 2.889 0 0 0 3.976-3.975l1.599-1.599.016-.016 2.62-2.62a.667.667 0 1 0-.944-.942l-2.26 2.26a7.14 7.14 0 0 0-3.49-.9c-3.56 0-5.726 2.48-6.701 3.96a2.49 2.49 0 0 0 0 2.746c.433.659 1.122 1.541 2.08 2.304L1.307 13.75a.667.667 0 0 0 0 .943m3.023-3.965 1.21-1.211A2.889 2.889 0 0 1 9.517 5.54l.984-.984a5.8 5.8 0 0 0-2.499-.556c-2.934 0-4.76 2.106-5.588 3.36a1.18 1.18 0 0 0 0 1.279c.397.6 1.033 1.413 1.917 2.088m2.15 2.446c.492.105 1.004.16 1.52.16 3.558 0 5.726-2.482 6.7-3.96.55-.835.55-1.914 0-2.747-.28-.425-.59-.83-.924-1.206a.667.667 0 0 0-.996.887c.291.327.563.681.808 1.053.252.382.252.896 0 1.279C12.76 9.894 10.934 12 8 12c-.423 0-.84-.044-1.24-.13a.668.668 0 0 0-.28 1.304",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-closed-no-width_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEyeClosedNoWidth;